<ion-content scrollY="false">
    <ion-list lines="full">

        <ion-item button="true" (click)="todaysSales()">
            <ion-label><fa-icon [icon]="['fal', 'bolt']" size="lg" [fixedWidth]="true"></fa-icon>Today's sales</ion-label>
        </ion-item>

    </ion-list>
</ion-content>